import React, { useContext } from 'react';

import { Layout, Popover, Text, TextButton, Clickable } from 'ds';
import { media } from 'context';
import NavIcon from 'ux/Layouts/Shared/Navigation/NavIcon';
import { isNavigationItemActive } from 'ux/Layouts/Shared/utils';
import { useLocation } from 'react-router-dom';
import { TENANT_ONBOARDING_CHECKLIST_PATH } from 'routes';

interface Props {
  isVisible: boolean;
  onClose: () => void;
  theme: 'light' | 'dark' | 'white' | 'dark_blue';
  isExpanded: boolean;
}

const OnboardingChecklistSkipPopover: React.FC<Props> = ({ isVisible, onClose, theme, isExpanded }) => {
  const { pathname } = useLocation();
  const { isMobile } = useContext(media);

  const desktopPopoverContent = (
    <Layout direction="column" gap={16} padding={24}>
      <Text size="body-sm" color="white">
        Track what's left to do and what we're handling for your office setup here.
      </Text>
      <TextButton text="Got it" textSize="body-sm" color="white" onClick={onClose} paddingX={false} paddingY={false} />
    </Layout>
  );

  const mobilePopoverContent = (
    <Layout direction="column" gap={16} padding={24}>
      <Text size="body-sm" color="white">
        Track what's left to do and what we're handling for your office setup here.
      </Text>
      <Clickable onClick={onClose}>
        <Text size="body-sm" color="white" semibold align="left">
          Got it
        </Text>
      </Clickable>
    </Layout>
  );

  const popoverContent = isMobile ? mobilePopoverContent : desktopPopoverContent;

  // For mobile, calculate offset to position popover above bottom nav
  // For 'top' placement, positive offset moves further away (higher), negative moves closer (lower)
  const getMobileOffset = (): [number, number] => {
    if (!isMobile) return [0, 8];
    // Large positive offset to position well above the bottom nav icon
    return [0, 120];
  };

  return (
    <Popover
      isVisible={isVisible}
      content={popoverContent}
      color="blue-500"
      placement={isMobile ? 'top' : 'right'}
      offset={getMobileOffset()}
      maxWidth={isMobile ? 342 : 300}
      popoverStyle={{ padding: 0, width: isMobile ? 342 : 300 }}
      onClickOutside={onClose}
    >
      <NavIcon
        iconName="rocket"
        href={TENANT_ONBOARDING_CHECKLIST_PATH}
        label={isMobile ? 'Checklist' : 'Onboarding checklist'}
        theme={theme}
        isActive={isNavigationItemActive({ href: TENANT_ONBOARDING_CHECKLIST_PATH, pathname })}
        isExpanded={isExpanded}
      />
    </Popover>
  );
};

export default OnboardingChecklistSkipPopover;
